import uuidv4 from 'uuid/v4'

export const genFlowId = () => uuidv4() || 'generatedUUID'

export const saveFlowToStorage = (flowId: string) => {
  window.localStorage.setItem('flowId', flowId)
}

export const removeFlowFromStorage = () => {
  window.localStorage.removeItem('flowId')
}

export const getFlowId = () => window.localStorage.getItem('flowId') || ''
